module.exports = __webpack_public_path__ + "static/media/Dispute.b18c2da8.png";